import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PAGES_URLS } from '../constants';

export const noAuthGuard: CanActivateFn = (route) => {
  const accessToken = localStorage.getItem('accessToken');
  // Returning from the IDP with new tokens: let the login page save them
  // instead of keeping a stale token left on this origin.
  const hasIncomingTokens =
    route.queryParamMap.has('accessToken') ||
    !!route.fragment?.includes('accessToken');

  if (accessToken && !hasIncomingTokens) {
    const router = inject(Router);
    void router.navigate([PAGES_URLS.HotelReservations]);
    return false;
  }

  return true;
};
